module.exports = __webpack_public_path__ + "img/三水区人民医院.93e7b5c1.png";